
// @ts-nocheck
import locale_en_46ts_4e84ba3a from "#nuxt-i18n/4e84ba3a";
import locale_cn_46ts_00bc5a67 from "#nuxt-i18n/00bc5a67";
import locale_kr_46ts_27ad555d from "#nuxt-i18n/27ad555d";
import locale_tr_46ts_fbeb2125 from "#nuxt-i18n/fbeb2125";

export const localeCodes =  [
  "en",
  "zh",
  "kr",
  "tr"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46ts_4e84ba3a",
      load: () => Promise.resolve(locale_en_46ts_4e84ba3a),
      cache: false
    }
  ],
  zh: [
    {
      key: "locale_cn_46ts_00bc5a67",
      load: () => Promise.resolve(locale_cn_46ts_00bc5a67),
      cache: false
    }
  ],
  kr: [
    {
      key: "locale_kr_46ts_27ad555d",
      load: () => Promise.resolve(locale_kr_46ts_27ad555d),
      cache: false
    }
  ],
  tr: [
    {
      key: "locale_tr_46ts_fbeb2125",
      load: () => Promise.resolve(locale_tr_46ts_fbeb2125),
      cache: false
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/576d2b5a" /* webpackChunkName: "config_i18n_46config_46ts_576d2b5a" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "En",
      longName: "English",
      _hreflang: "en",
      _sitemap: "en",
      files: [
        {
          path: "/home/runner/_work/injective-helix/injective-helix/i18n/locales/en.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "zh",
      name: "中文",
      longName: "中文",
      _hreflang: "zh",
      _sitemap: "zh",
      files: [
        {
          path: "/home/runner/_work/injective-helix/injective-helix/i18n/locales/cn.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "kr",
      name: "Kr",
      longName: "한국어",
      _hreflang: "kr",
      _sitemap: "kr",
      files: [
        {
          path: "/home/runner/_work/injective-helix/injective-helix/i18n/locales/kr.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "tr",
      name: "Tr",
      longName: "Türkçe",
      _hreflang: "tr",
      _sitemap: "tr",
      files: [
        {
          path: "/home/runner/_work/injective-helix/injective-helix/i18n/locales/tr.ts",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "En",
    longName: "English",
    _hreflang: "en",
    _sitemap: "en",
    files: [
      {
        path: "/home/runner/_work/injective-helix/injective-helix/i18n/locales/en.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "zh",
    name: "中文",
    longName: "中文",
    _hreflang: "zh",
    _sitemap: "zh",
    files: [
      {
        path: "/home/runner/_work/injective-helix/injective-helix/i18n/locales/cn.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "kr",
    name: "Kr",
    longName: "한국어",
    _hreflang: "kr",
    _sitemap: "kr",
    files: [
      {
        path: "/home/runner/_work/injective-helix/injective-helix/i18n/locales/kr.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "tr",
    name: "Tr",
    longName: "Türkçe",
    _hreflang: "tr",
    _sitemap: "tr",
    files: [
      {
        path: "/home/runner/_work/injective-helix/injective-helix/i18n/locales/tr.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/